function _typeof(o) {
  "@babel/helpers - typeof";
  return (
    (_typeof =
      "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
        ? function (o) {
          return typeof o;
        }
        : function (o) {
          return o &&
            "function" == typeof Symbol &&
            o.constructor === Symbol &&
            o !== Symbol.prototype
            ? "symbol"
            : typeof o;
        }),
    _typeof(o)
  );
}
define("SuiteDB.SDBQuoteImprovements.SDBQuoteImprovement", [
  "SuiteDB.SDBQuoteImprovements.SDBQuoteImprovement.View",
  "Utils",
  "SuiteDB.SDBQuoteImprovements.SDBQuoteImprovement.Model",
  "SDB.SDBLocations.Model",
  "Profile.Model",
  "SuiteDB.SDBQuoteImprovements.Cart.View",
  "LiveOrder.Model",
  "SDB.SelectWheelsOrTires.SS2Model",
  "SDB.SelectYourVehicle.View",
  "SDB.Modal.Content.View",
  "SuiteDB.SDBQuoteImprovements.PlaceOrderButton.View",
  "CCAW.OrderTerms.Consent.View",
  "SuiteDB.SDBOtherCharges.SDBOtherCharges.Model",
  "Address.Utils",
  "UrlHelper",
], function (
  SDBQuoteImprovementView,
  Utils,
  SDBQuoteImprovementModel,
  SDBLocationsModel,
  ProfileModel,
  SDBQuoteCartView,
  LiveOrderModel,
  SelectYourVehicleModel,
  SDBSelectYourVehicleView,
  SDBModalContentView,
  SDBPlaceOrderButtonView,
  ConsentView,
  SDBOtherChargesModel,
  AddressUtils,
  UrlHelper
) {
  "use strict";

  return {
    mountToApp: function mountToApp(container) {
      /** @type {LayoutComponent} */
      var layout = container.getComponent("Layout");
      var Model = SDBQuoteImprovementModel.getInstance();
      var Checkout = container.getComponent("Checkout");
      var LocationsModel = SDBLocationsModel.getInstance();
      var Profile = ProfileModel.getInstance();
      var LiveOrder = LiveOrderModel.getInstance();
      var vehicleModel = SelectYourVehicleModel.getInstance();
      var otherChargesModel = SDBOtherChargesModel.getInstance();
      var Address = AddressUtils.getInstance({
        Application: container,
      });
      if (layout) {
        layout.addChildView("SDBQuoteCart", function () {
          return new SDBQuoteImprovementView({ container: container });
        });
        layout.registerView("Cart.AddToQuote.View", function () {
          return new SDBQuoteCartView({
            container: container,
            LiveOrder: LiveOrder,
          });
        });
      }

      if (Utils.isInShopping()) {
        var addToQuoteView = require("ProductDetailToQuote.View");
        var itemAdded;
        addToQuoteView.prototype.addItemToQuote = _.wrap(
          addToQuoteView.prototype.addItemToQuote,
          function (fn) {
            itemAdded = true;
            fn.apply(this, Array.prototype.slice.call(arguments, 1));
          }
        );
        addToQuoteView.prototype.getContext = _.wrap(
          addToQuoteView.prototype.getContext,
          function (fn) {
            var ctx = fn.apply(this, Array.prototype.slice.call(arguments, 1));
            if (!itemAdded) return ctx;
            itemAdded = false;
            var change = !Model.get("QuoteChanged");
            Model.set("QuoteChanged", change);
            return ctx;
          }
        );
      } else if (!Checkout) {
        try {
          var QuoteDetailsView = require("Quote.Details.View");
          QuoteDetailsView =
            QuoteDetailsView.QuoteDetailsView || QuoteDetailsView;
          QuoteDetailsView.prototype.getContext = _.wrap(
            QuoteDetailsView.prototype.getContext,
            function (fn) {
              var context = fn.apply(
                this,
                Array.prototype.slice.call(arguments, 1)
              );
              layout.registerView(
                "SDBQuoteImprovements.PlaceOrderButton.View",
                function () {
                  return new SDBPlaceOrderButtonView({
                    container: container,
                    quoteInfo: context,
                  });
                }
              );
              var purchasable =
                context.model.get("purchasablestatus").isPurchasable;
              var permissions = context.hasPermission;
              var hasHidePriceItem = false;
              var lines = context.model.get("lines").models;
              for (var i = 0; i < lines.length; i++) {
                var hasPriceHidden = lines[i]
                  .get("item")
                  .get("custitem_sdb_item_hide_price");
                if (hasPriceHidden) {
                  hasHidePriceItem = true;
                  break;
                }
              }
              //show price if approved or processed
              showPrice =
                context.model.attributes.entitystatus.id === "13" ||
                (purchasable && permissions) ||
                (permissions && !hasHidePriceItem);
              context.showPrice = showPrice;

              //prevent processing if the subsidiary was disabled
              var subsidiary = context.model.attributes.subsidiary;
              var locationsList = LocationsModel.getLocations();
              var onlineLocation = LocationsModel.get("onlineLocation");
              // var locationIsAvailable = _.some(locationsList, { internalid: subsidiary }) ||
              // 	onlineLocation.internalid === subsidiary;
              //*prevent purchasing if the location is online
              var locationIsAvailable = _.some(locationsList, {
                internalid: subsidiary,
              });
              if (!locationIsAvailable) {
                context.model.get("purchasablestatus").isPurchasable = false;
                context.hasPermissionAndHasErrors = true;
                context.purchaseValidationErrors.push(
                  "The location for this quote is no longer available on the website"
                );
              }
              return context;
            }
          );
          var showPrice = false;
          var TransactionLineViewsCellNavigableView = require("Transaction.Line.Views.Cell.Navigable.View");
          if (
            TransactionLineViewsCellNavigableView.TransactionLineViewsCellNavigableView
          )
            TransactionLineViewsCellNavigableView =
              TransactionLineViewsCellNavigableView.TransactionLineViewsCellNavigableView;
          TransactionLineViewsCellNavigableView.prototype.getContext = _.wrap(
            TransactionLineViewsCellNavigableView.prototype.getContext,
            function (fn) {
              var context = fn.apply(
                this,
                Array.prototype.slice.call(arguments, 1)
              );
              if (
                context.model.get("item").get("custitem_sdb_item_hide_price") &&
                !showPrice
              )
                context.hidePrice = true;
              return context;
            }
          );
        } catch (error) {
          console.error("error in getContext", error);
        }

        //only load entry point specific modules when they are sure to exist
        var QuoteListView = require("Quote.List.View");
        var QuoteCollection = require("Quote.Collection");
        var QuoteModel = require("Quote.Model");
        QuoteModel = QuoteModel.QuoteModel || QuoteModel;
        var ListHeaderView = require("ListHeader.View");
        ListHeaderView = ListHeaderView.ListHeaderView || ListHeaderView;
        var RequestQuoteWizardModuleConfirmation = require("RequestQuoteWizard.Module.Confirmation");

        //variables used to keep track of processes while changing the quotes list
        var selectedQuoteStatus;
        var currentQuote;
        var currentQuoteLoaded = false;
        var quoteCollection;
        var originalQuoteCollection;
        var order = 1;
        var fetchingQuotes = true;
        var quoteListInstance;
        var quotesByPage = {
          total: 0,
        };

        var quoteCollectionInstance = new QuoteCollection();
        //retrieve the first page of quotes, and then calculate how many more times to fetch pages asynchronously
        var fetchQuotes = function fetchQuotes(page, view) {
          if (!page) {
            originalQuoteCollection = new QuoteCollection();
            quotesByPage = {
              total: 0,
            };
            fetchingQuotes = true;
          }
          var data = {
            page: page || 1,
          };
          if (view) {
            data.sort = view.selectedSort.value;
            data.order = view.order;
          }
          quoteCollectionInstance
            .fetch({
              async: !!page,
              data: data,
            })
            .then(function (result) {
              if (!result.records.length) {
                fetchingQuotes = false;
                if (quoteListInstance && currentQuoteLoaded)
                  quoteListInstance.render();
                return;
              }
              var quotesFetched = [];
              for (var i = 0; i < result.records.length; i++) {
                var quote = new QuoteModel(result.records[i]);
                if (
                  !quote.amount ||
                  (["processed", "closed"].indexOf(quote.status.internalid) ===
                    -1 &&
                    quote.get("entitystatus").id !== "12")
                ) {
                  quote.clearPrice();
                }
                quotesFetched.push(quote);
              }
              quotesByPage[page || 1] = quotesFetched;
              quotesByPage.total += quotesFetched.length;
              if (
                result.totalRecordsFound &&
                quotesByPage.total === result.totalRecordsFound
              ) {
                fetchingQuotes = false;
                for (var p in quotesByPage) {
                  var quotePage = quotesByPage[p];
                  _.each(quotePage, function (quote) {
                    originalQuoteCollection.add(quote);
                  });
                }
                if (quoteListInstance && currentQuoteLoaded)
                  quoteListInstance.render();
              }
              if (page) return;

              originalQuoteCollection.recordsPerPage =
                result.recordsPerPage || 20;
              originalQuoteCollection.totalRecordsFound =
                result.totalRecordsFound;
              var pages = Math.ceil(
                result.totalRecordsFound / result.recordsPerPage
              );
              for (var i = 2; i <= pages; i++) fetchQuotes(i, view);
            });
        }

        //auxiliary function to erase the price of a quote model
        QuoteModel.prototype.clearPrice = function () {
          var quote = this;
          var noPriceMessage = Utils.translate(
            "Price will be posted once quote is approved"
          );
          quote.amount = noPriceMessage;
          quote.amount_formatted = noPriceMessage;
          quote.total = noPriceMessage;
          quote.total_formatted = noPriceMessage;
          quote.attributes.amount = noPriceMessage;
          quote.attributes.amount_formatted = noPriceMessage;
          quote.attributes.total = noPriceMessage;
          quote.attributes.total_formatted = noPriceMessage;
        };

        //auxiliary function to copy a quote collection
        QuoteCollection.prototype.clone = function () {
          var copy = new QuoteCollection();
          copy.models = [];
          copy._byId = {};
          var collection = this;
          _.each(Object.keys(this), function (key) {
            if (!copy[key]) copy[key] = collection[key];
          });
          _.each(this.models, function (element) {
            copy.add(new QuoteModel(_.clone(element)));
          });
          return copy;
        };

        QuoteListView.prototype.getContext = _.wrap(
          QuoteListView.prototype.getContext,
          function (fn) {
            //if still loading then show the loading message on the page
            this.isLoading = fetchingQuotes || !currentQuoteLoaded;
            return fn.apply(this, Array.prototype.slice.call(arguments, 1));
          }
        );
        QuoteListView.prototype.initialize = _.wrap(
          QuoteListView.prototype.initialize,
          function (fn) {
            quoteListInstance = this;
            //since the filtering is customized we erase the default url param for filtering
            var url = Backbone.history.fragment;
            url = UrlHelper.UrlHelper.removeUrlParameter(url, "filter");
            Backbone.history.navigate(url, { trigger: false });
            fn.apply(this, _.toArray(arguments).slice(1));

            //custom filter list
            this.listHeader.filters = [
              {
                value: "ALL",
                name: Utils.translate("Show all statuses"),
                selected: true,
              },
              {
                value: "open",
                name: Utils.translate("Open"),
              },
              {
                value: "processed",
                name: Utils.translate("Processed"),
              },
              {
                value: "closed",
                name: Utils.translate("Closed"),
              },
              {
                value: "expired",
                name: Utils.translate("Expired"),
              },
              {
                value: "voided",
                name: Utils.translate("Voided"),
              },
            ];

            //we load the info of the current quote and reset saved info
            currentQuoteLoaded = false;
            selectedQuoteStatus = null;
            container.ProductListModule.Utils.getRequestAQuoteProductList().done(
              function (json) {
                currentQuoteLoaded = true;
                if (!json.items || !json.items.length) {
                  if (quoteListInstance && !fetchingQuotes)
                    quoteListInstance.render();
                  return;
                }
                //create quote model from staged quote json
                currentQuote = json;
                currentQuote.recordtype = "estimate";
                currentQuote.tranid = "Pending";
                currentQuote.trandate = currentQuote.lastmodifieddate;
                currentQuote.status = { internalid: "staged", name: "Staged" };
                currentQuote.entitystatus = { id: "", name: "" };
                currentQuote.subsidiary =
                  LocationsModel.getSelectedLocation() || "CCAW";
                currentQuote.currency = Profile.get("currency");
                currentQuote = new QuoteModel(currentQuote);
                if (quoteListInstance && !fetchingQuotes)
                  quoteListInstance.render();
              }
            );
          }
        );
        QuoteListView.prototype._buildResultsView = _.wrap(
          QuoteListView.prototype._buildResultsView,
          function (fn) {
            if (!originalQuoteCollection || this.isLoading || fetchingQuotes)
              return fn.apply(this, _.toArray(arguments).slice(1));

            var self = this;
            this.collection = new QuoteCollection();
            var filteredQuotes = _.filter(
              originalQuoteCollection.models,
              function (quoteModel) {
                return (
                  !selectedQuoteStatus ||
                  selectedQuoteStatus === "ALL" ||
                  quoteModel.status.internalid === selectedQuoteStatus
                );
              }
            );
            //put only the quotes for the page on the collection
            for (
              var i =
                (this.listHeader.page - 1) *
                (originalQuoteCollection.recordsPerPage || 20);
              i < filteredQuotes.length;
              i++
            ) {
              if (
                self.collection.length >= originalQuoteCollection.recordsPerPage
              )
                break;
              var quote = filteredQuotes[i];
              self.collection.add(quote);
            }
            this.collection.totalRecordsFound = filteredQuotes.length;
            this.collection.recordsPerPage =
              originalQuoteCollection.recordsPerPage;

            //add staged quote to the list
            if (
              currentQuote &&
              this.listHeader &&
              (!selectedQuoteStatus ||
                selectedQuoteStatus ===
                this.listHeader.getDefaultFilter().value) &&
              this.listHeader.order === 1 &&
              this.listHeader.page === 1
            ) {
              this.collection.add(currentQuote, { at: 0 });
            }

            var buildResults = fn.apply(this, _.toArray(arguments).slice(1));

            _.each(buildResults.collection.models, function (model) {
              var subsidiaryIndex = _.findIndex(
                model.get("columns"),
                function (value) {
                  return value.name == "subsidiary";
                }
              );
              if (subsidiaryIndex === -1) return;
              var subsidiary = model.get("columns")[subsidiaryIndex];
              var originalModel = _.findWhere(originalQuoteCollection.models, {
                internalid: model.id,
              });
              if (!originalModel) return;
              var subsidiaryValue =
                originalModel.subsidiary || originalModel.attributes.subsidiary;
              if (
                model.get("title").includes("Pending") &&
                !_.isArray(subsidiaryValue) &&
                _typeof(subsidiaryValue) === "object"
              )
                subsidiary.value = subsidiaryValue.name;
              else {
                if (subsidiary.value == "6") subsidiary.value = "CCAW";
                var subsidiaryRecord = _.where(LocationsModel.attributes, {
                  internalid: subsidiary.value,
                });
                if (subsidiaryRecord.length)
                  subsidiary.value = subsidiaryRecord[0].name;
              }
            });

            if (this.listHeader) {
              this.listHeader.collection = this.collection;
              this.listHeader.render();
            }
            return buildResults;
          }
        );

        //custom filtering logic
        ListHeaderView.prototype.filterHandler = _.wrap(
          ListHeaderView.prototype.filterHandler,
          function (fn, e) {
            if (Backbone.history.location.href.indexOf("quotes") == -1)
              return fn.apply(this, _.toArray(arguments).slice(1));
            selectedQuoteStatus = e.target.value;
            return fn.apply(this, _.toArray(arguments).slice(1));
          }
        );
        ListHeaderView.prototype.getContext = _.wrap(
          ListHeaderView.prototype.getContext,
          function (fn) {
            if (Backbone.history.location.href.indexOf("quotes") == -1)
              return fn.apply(this, _.toArray(arguments).slice(1));
            if (!selectedQuoteStatus)
              return fn.apply(this, _.toArray(arguments).slice(1));
            var contextSelf = this;
            _.each(this.filters, function (filter) {
              if (filter.value === selectedQuoteStatus) {
                filter.selected = true;
                contextSelf.selectedFilter = filter;
              } else filter.selected = false;
            });
            return fn.apply(this, _.toArray(arguments).slice(1));
          }
        );
        //replace filter used by core with the default one in order to use custom logic
        ListHeaderView.prototype.updateUrl = _.wrap(
          ListHeaderView.prototype.updateUrl,
          function (fn) {
            if (Backbone.history.location.href.indexOf("quotes") == -1)
              return fn.apply(this, _.toArray(arguments).slice(1));
            this.selectedFilter = this.getDefaultFilter();
            return fn.apply(this, _.toArray(arguments).slice(1));
          }
        );
        //update collecton manually due to it not updating automatically after being replaced
        ListHeaderView.prototype.updateCollection = _.wrap(
          ListHeaderView.prototype.updateCollection,
          function (fn) {
            if (Backbone.history.location.href.indexOf("quotes") == -1)
              return fn.apply(this, _.toArray(arguments).slice(1));
            fetchQuotes(0, this);
            return this;
          }
        );

        //update item count for the quote icon
        var RequestQuoteWizardModuleItemsLineQuantityView = require("RequestQuoteWizard.Module.Items.Line.Quantity.View");
        RequestQuoteWizardModuleItemsLineQuantityView.prototype.setQuantity =
          _.wrap(
            RequestQuoteWizardModuleItemsLineQuantityView.prototype.setQuantity,
            function (fn) {
              var oldQuantity = this.model.get("quantity");
              var ctx = fn.apply(this, _.toArray(arguments).slice(1));
              var newQuantity = this.model.get("quantity");
              Model.set("QuoteQuantityChanged", newQuantity - oldQuantity);
              return ctx;
            }
          );
        var RequestQuoteWizardModuleItems = require("RequestQuoteWizard.Module.Items");
        RequestQuoteWizardModuleItems.prototype.getContext = _.wrap(
          RequestQuoteWizardModuleItems.prototype.getContext,
          function (fn) {
            var ctx = fn.apply(this, _.toArray(arguments).slice(1));
            var quantity = this.model.get("lines").models.reduce(function (
              sum,
              item
            ) {
              return sum + item.get("quantity");
            }, 0);
            Model.set("QuoteSetQuantity", quantity);
            return ctx;
          }
        );

        //manage shipping address location change
        var RequestQuoteWizardStep = require("RequestQuoteWizard.Step");
        var shippingHandlerAdded = false;
        RequestQuoteWizardStep.prototype.initialize = _.wrap(
          RequestQuoteWizardStep.prototype.initialize,
          function (fn) {
            if (!shippingHandlerAdded) {
              shippingHandlerAdded = true;
              this.options.wizard.model.on(
                "change:shipaddress",
                function (model, value) {
                  if (!model.previousAttributes().shipaddress) return;
                  Address.shipAddrChangeHandler(model, value);
                }
              );
            }
            return fn.apply(this, _.toArray(arguments).slice(1));
          }
        );

        //set selected vehicle info
        RequestQuoteWizardModuleConfirmation.prototype.getContext = _.wrap(
          RequestQuoteWizardModuleConfirmation.prototype.getContext,
          function (fn) {
            var ctx = fn.apply(this, _.toArray(arguments).slice(1));
            Model.set("QuoteSetQuantity", 0);

            var vehicleCookie = vehicleModel.getCookieOptions(["vehicle"]);
            if (vehicleCookie.length) {
              vehicleCookie = JSON.parse(
                vehicleCookie[0].trim().replace("vehicle=", "")
              );
            }
            if (!(_.isObject(vehicleCookie) && !_.isArray(vehicleCookie))) {
              vehicleCookie = null;
            }

            // vehicleConfigId from RS API on the vehicle selection modal
            var vehicleConfigCookie = vehicleModel.getCookieOptions([
              "vehicleConfig",
            ]);
            // console.log('vehicleConfigCookie', vehicleConfigCookie);
            if (vehicleConfigCookie.length) {
              vehicleConfigCookie = vehicleConfigCookie[0]
                .trim()
                .replace("vehicleConfig=", "");
              // console.log('vehicleConfigCookie', vehicleConfigCookie);
            }
            if (!vehicleConfigCookie) {
              vehicleConfigCookie = null;
            }
            if (vehicleConfigCookie) {
              if (vehicleCookie && !vehicleCookie.config) {
                vehicleCookie.config = vehicleConfigCookie;
              } else if (!vehicleCookie) {
                vehicleCookie = { config: vehicleConfigCookie };
              }
            }
            // console.log('vehicleCookie', vehicleCookie);

            Model.fetch({
              async: true,
              data: {
                selectedVehicle: JSON.stringify(vehicleCookie),
                recordId: ctx.quoteTranId,
              },
            });
            return ctx;
          }
        );

        //fix issue with the shipping address of the quotes not displaying when turning them into an order
        var OrderWizardModuleShowShipments = require("OrderWizard.Module.ShowShipments");
        OrderWizardModuleShowShipments.prototype.getContext = _.wrap(
          OrderWizardModuleShowShipments.prototype.getContext,
          function (fn) {
            this.addressSource = this.model.attributes.addresses;
            var context = fn.apply(this, _.toArray(arguments).slice(1));
            context.showShippingMetod = false;
            return context;
          }
        );

        //custom logic to manage the quote to order transformation
        var QuoteToSalesOrderModel = require("QuoteToSalesOrder.Model");
        var quoteModelSelf;
        QuoteToSalesOrderModel.prototype.submit = _.wrap(
          QuoteToSalesOrderModel.prototype.submit,
          function (fn) {
            quoteModelSelf = this;
            var selectedLocation = LocationsModel.getSelectedLocation();
            if (!selectedLocation) {
              return fn.apply(this, Array.prototype.slice.call(arguments, 1));
            }
            var deferred = $.Deferred();

            Model.save(quoteModelSelf, {
              wait: false,
            }).then(function (response, status) {
              quoteModelSelf
                .get("confirmation")
                .set("addresses", quoteModelSelf.get("addresses"));
              quoteModelSelf
                .get("confirmation")
                .set("shipmethods", quoteModelSelf.get("shipmethods"));
              quoteModelSelf
                .get("confirmation")
                .set("lines", quoteModelSelf.get("lines"));
              quoteModelSelf
                .get("confirmation")
                .set("paymentmethods", quoteModelSelf.get("paymentmethods"));
              quoteModelSelf
                .get("confirmation")
                .set("summary", quoteModelSelf.get("summary"));
              quoteModelSelf
                .get("confirmation")
                .set("internalid", response.responseObject.id);
              QtOWizardRouter.goToNextStep();
            });
            return deferred.promise();
          }
        );
        var QuoteToSalesOrderWizardRouter = require("QuoteToSalesOrderWizard.Router");
        var QtOWizardRouter;
        QuoteToSalesOrderWizardRouter.prototype.runStep = _.wrap(
          QuoteToSalesOrderWizardRouter.prototype.runStep,
          function (fn) {
            if (!QtOWizardRouter) {
              QtOWizardRouter = this;
              otherChargesModel.set("quoteSummaryView", quoteSummaryView);
              otherChargesModel.set("QuoteToSalesOrderModel", this.model);
            }
            return fn.apply(this, Array.prototype.slice.call(arguments, 1));
          }
        );
        var GlobalViewsFormatPaymentMethodView = require("GlobalViews.FormatPaymentMethod.View");
        GlobalViewsFormatPaymentMethodView.prototype.getContext = _.wrap(
          GlobalViewsFormatPaymentMethodView.prototype.getContext,
          function (fn) {
            if (
              Backbone.history.location.href.indexOf(
                "quotetosalesorder-confirmation"
              ) != -1
            )
              this.model.get("creditcard").ccnumber =
                this.model.get("creditcard").cardlastfourdigits;
            return fn.apply(this, Array.prototype.slice.call(arguments, 1));
          }
        );
        var OrderWizardModuleCartSummary = require("OrderWizard.Module.CartSummary");
        var quoteSummaryView;
        OrderWizardModuleCartSummary.prototype.initialize = _.wrap(
          OrderWizardModuleCartSummary.prototype.initialize,
          function (fn) {
            if (!quoteSummaryView) quoteSummaryView = this;
            return fn.apply(this, Array.prototype.slice.call(arguments, 1));
          }
        );
        // Check if the current wizard is the Request Quote Wizard
        // and if the current step is 'request-a-quote'
        // If so, check if a vehicle is selected before proceeding
        // If a vehicle is not selected, show the vehicle selection modal
        // Otherwise, proceed with the original submit function
        // This is to ensure that the vehicle selection is enforced
        // only for the Request Quote Wizard and the 'request-a-quote' step
        var Wizard = require("Wizard.View");
        Wizard.prototype.submit = _.wrap(
          Wizard.prototype.submit,
          function (fn) {
            var _proto$attributes;
            var proto = Object.getPrototypeOf(this);

            var layout = container.getComponent("Layout");
            if (
              proto &&
              (proto === null ||
                proto === void 0 ||
                (_proto$attributes = proto.attributes) === null ||
                _proto$attributes === void 0
                ? void 0
                : _proto$attributes.id) === "request-quote-wizard"
            ) {
              var currentStep = this.wizard.getCurrentStep();
              if (
                currentStep &&
                currentStep.step_url &&
                currentStep.step_url === "request-a-quote"
              ) {
                var vehicle = null;
                var cookies = document.cookie.split(";");
                if (cookies && cookies.length > 1) {
                  vehicle = cookies.find(function (cookie) {
                    return cookie.indexOf("vehicle=") !== -1;
                  });
                }

                if (!vehicle) {
                  var modalView = new SDBModalContentView({
                    parentView: this.parentView,
                    contentView: SDBSelectYourVehicleView,
                    container: container,
                    pageHeader: "What vehicle are you shopping for today?",
                    showContinue: true,
                    requiresVehicleSelection: true,
                    requiresVehicleSelectionPayload: {
                      callback: fn,
                      that: this,
                      arguments: arguments,
                    },
                  });
                  layout.showContent(modalView, { showInModal: true });
                } else {
                  return fn.apply(this, _.toArray(arguments).slice(1));
                }
              }
            } else {
              return fn.apply(this, _.toArray(arguments).slice(1));
            }
          }
        );
        if (
          Backbone.history.location.hash.indexOf("quotetosalesorder-review") !==
          -1
        ) {
          var layout = container.getComponent("Layout");
          layout.registerView("CCAW.OrderTerms.Consent.View", function () {
            return new ConsentView({
              container: container,
              showOrderTerms: true,
            });
          });
        }
      }
    },
  };
});
